// extracted by mini-css-extract-plugin
export var historyList = "biography-module--historyList--ccxTn";
export var historyListEn = "biography-module--historyListEn--wOaEC";